import { render, staticRenderFns } from "./vertical.vue?vue&type=template&id=bf80e37c"
import script from "./vertical.vue?vue&type=script&lang=ts"
export * from "./vertical.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports